import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SearchByPlanLogisticsPapForm from '../../components/management/SearchByPlanLogisticsPapForm'
import { saveServicesConfirmationLogitics } from '../../actions/dossier/serviceDossier'
import { translate } from 'react-polyglot'
import { fetchPlanLogiticsPap, resetFilters } from '../../actions/search/search'
import { getFormValues } from 'redux-form'
import { openModal } from '../../actions/common'

export function mapStateToProps (state) {
  return {
    ...state.search,
    formValues: getFormValues('SearchByPlanLogisticsPapForm')(state)
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      resetFilters,
      saveServicesConfirmationLogitics,
      fetchPlanLogiticsPap,
      openModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SearchByPlanLogisticsPapForm))
